import "./Blog.scss";

export class BaseBlog
{
	constructor()
	{
		this.Initialize();
	}

	public Initialize(): void
	{
	}
}